/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_Paragraph_0Inputs */

const en_visa_l1_paragraph_0 = /** @type {(inputs: Visa_L1_Paragraph_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eligibility often turns on the corporate relationship, the employee's prior service abroad, and whether the duties and business evidence support the requested classification.`)
};

const pt_visa_l1_paragraph_0 = /** @type {(inputs: Visa_L1_Paragraph_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A elegibilidade geralmente depende do relacionamento corporativo, do serviço anterior do funcionário no exterior e se as funções e evidências comerciais apoiam a classificação solicitada.`)
};

const es_visa_l1_paragraph_0 = /** @type {(inputs: Visa_L1_Paragraph_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La elegibilidad a menudo depende de la relación corporativa, el servicio previo del empleado en el extranjero y si las funciones y la evidencia comercial respaldan la clasificación solicitada.`)
};

/**
* | output |
* | --- |
* | "Eligibility often turns on the corporate relationship, the employee's prior service abroad, and whether the duties and business evidence support the requeste..." |
*
* @param {Visa_L1_Paragraph_0Inputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_paragraph_0 = /** @type {((inputs?: Visa_L1_Paragraph_0Inputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_Paragraph_0Inputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_paragraph_0(inputs)
	if (locale === "es") return es_visa_l1_paragraph_0(inputs)
	return en_visa_l1_paragraph_0(inputs)
});